const PAGE_PARAM_PATTERN = /^page=/

function buildPageHref(baseUrl = '', page = 1) {
  const [path, query = ''] = baseUrl.split('?')
  const params = query.split('&').filter((param) => param && !PAGE_PARAM_PATTERN.test(param))

  if (Number(page) > 1) {
    params.push(`page=${Number(page)}`)
  }

  if (!params.length) {
    return path
  }

  return `${path}?${params.sort().join('&')}`
}

export default buildPageHref
